export default function SolutionSection() {
  const steps = [
    {
      icon: 'ri-phone-line',
      title: 'Rendez-vous gratuit',
      description: 'Nous analysons votre restaurant et définissons ensemble votre stratégie de marques virtuelles'
    },
    {
      icon: 'ri-palette-line', 
      title: 'Création des marques',
      description: 'Nous créons 2-3 marques virtuelles adaptées à votre cuisine et à votre marché local'
    },
    {
      icon: 'ri-store-line',
      title: 'Lancement sur les plateformes',
      description: 'Mise en ligne sur Uber Eats, Deliveroo et autres plateformes de livraison'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Suivi et optimisation',
      description: 'Nous optimisons en continu pour maximiser vos ventes et votre visibilité'
    }
  ];

  return (
    <section id="solution" className="py-20 bg-white relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Comment <span className="text-[#9EFD38]">VirtualEat</span> fonctionne
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un processus simple en 4 étapes pour transformer votre restaurant
          </p>
          
          {/* Badge central */}
          <div className="inline-flex bg-[#9EFD38] text-black px-6 py-3 rounded-full font-bold text-sm items-center shadow-lg mt-6">
            <i className="ri-shield-check-line mr-2"></i>
            0€ d'investissement • Résultats garantis
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center group">
              <div className="relative">
                <div className="w-20 h-20 bg-[#9EFD38] rounded-full flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                  <i className={`${step.icon} text-3xl text-black`}></i>
                </div>
                <div className="absolute -top-2 -right-2 bg-green-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold">
                  {index + 1}
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
              
              {/* Badge sur l'étape 1 */}
              {index === 0 && (
                <div className="mt-4 inline-block bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-bold">
                  GRATUIT
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-16">
          <div className="bg-gray-50 p-8 rounded-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              💡 Pourquoi les marques virtuelles fonctionnent-elles ?
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Les consommateurs commandent plus souvent quand ils ont l'impression de découvrir de nouveaux restaurants. 
              Avec VirtualEat, votre cuisine devient 3 restaurants différents, triplant votre visibilité !
            </p>
            
            {/* Badge final */}
            <div className="mt-6 inline-flex bg-[#9EFD38] text-black px-6 py-3 rounded-full font-bold text-sm items-center shadow-lg">
              <i className="ri-shield-check-line mr-2"></i>
              Stratégie testée et approuvée
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
